import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {barElementClasses, BarPlot} from '@mui/x-charts/BarChart';
import {MoreVertOutlined, TrendingUpOutlined} from '@mui/icons-material';
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import {ChartContainer, ChartsTooltip, ChartsXAxis} from "@mui/x-charts";
import {XYVO} from "@/service/analyze";
import {ChartsLoadingOverlay} from "@mui/x-charts/ChartsOverlay";

interface SalesChanceProps {
    recent7MonthChances?: XYVO[]
    loading: boolean
}

export default function SalesChance({recent7MonthChances, loading}: SalesChanceProps) {

    return (
        <Card variant="outlined" sx={{width: '100%', bgcolor: '#e5f5ff', height: 320}}>
            <CardContent>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'start'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        商机金额
                    </Typography>
                    <MoreVertOutlined color={'action'}/>
                </Stack>
                {/*<Stack my={2} mx={1} direction={'row'} gap={4}>*/}
                {/*    <IconButton sx={{backgroundColor: "#fff", padding: '0px 20px', borderRadius: '9999px'}} color={'default'}>*/}
                {/*        <TrendingUpOutlined/>*/}
                {/*    </IconButton>*/}
                {/*    <Stack>*/}
                {/*        <Typography component="h2" fontWeight={600} variant="subtitle2">*/}
                {/*            283%*/}
                {/*        </Typography>*/}
                {/*        <Typography component="h2" variant='body2'>*/}
                {/*            ROI*/}
                {/*        </Typography>*/}
                {/*    </Stack>*/}
                {/*    <Divider orientation="vertical" variant="middle" flexItem/>*/}
                {/*    <Stack>*/}
                {/*        <Typography component="h2" fontWeight={600} color={'info'} variant="subtitle2">*/}
                {/*            +24%*/}
                {/*        </Typography>*/}
                {/*        <Typography component="h2" variant='body2'>*/}
                {/*            二月*/}
                {/*        </Typography>*/}
                {/*    </Stack>*/}
                {/*</Stack>*/}
                <ChartContainer
                    height={260}
                    margin={{bottom: 0, top: 0, left: 10, right: 10}}
                    sx={{
                        [`& .${barElementClasses.root}`]: {
                            strokeWidth: 1,
                        },
                    }
                    }
                    localeText={{loading: loading ? "加载中" : ''}}
                    series={[{data: recent7MonthChances?.map(item => item.y) || [], label: '商机金额', type: 'bar'}]}
                    xAxis={[{
                        scaleType: 'band',
                        categoryGapRatio: 0.4,
                        data: recent7MonthChances?.map(item => `${item.x}月`) || [],
                        colorMap: {colors: ['#d5e4ed', '#d5e4ed', '#d5e4ed', '#d5e4ed', '#22aeff', '#d5e4ed', '#d5e4ed'], type: 'ordinal'}
                    }] as any}
                    yAxis={[{position: 'none'}]}
                >
                    <BarPlot slotProps={{bar: {rx: 20, ry: 20,},}}/>
                    <ChartsTooltip/>
                    <ChartsXAxis disableLine disableTicks/>
                    <ChartsLoadingOverlay/>
                </ChartContainer>

                {/*<BarChart*/}
                {/*    borderRadius={8}*/}
                {/*    colors={colorPalette}*/}
                {/*    xAxis={*/}
                {/*        [*/}
                {/*            {*/}
                {/*                scaleType: 'band',*/}
                {/*                categoryGapRatio: 0.5,*/}
                {/*                data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],*/}
                {/*            },*/}
                {/*        ] as any*/}
                {/*    }*/}
                {/*    series={[*/}
                {/*        {*/}
                {/*            id: 'page-views',*/}
                {/*            label: 'Page views',*/}
                {/*            data: [2234, 3872, 2998, 4125, 3357, 2789, 2998],*/}
                {/*            stack: 'A',*/}
                {/*        },*/}
                {/*        {*/}
                {/*            id: 'downloads',*/}
                {/*            label: 'Downloads',*/}
                {/*            data: [3098, 4215, 2384, 2101, 4752, 3593, 2384],*/}
                {/*            stack: 'A',*/}
                {/*        },*/}
                {/*        {*/}
                {/*            id: 'conversions',*/}
                {/*            label: 'Conversions',*/}
                {/*            data: [4051, 2275, 3129, 4693, 3904, 2038, 2275],*/}
                {/*            stack: 'A',*/}
                {/*        },*/}
                {/*    ]}*/}
                {/*    height={234}*/}
                {/*    margin={{left: 50, right: 0, top: 20, bottom: 20}}*/}
                {/*    grid={{horizontal: true}}*/}
                {/*    slotProps={{*/}
                {/*        legend: {*/}
                {/*            hidden: true,*/}
                {/*        },*/}
                {/*    }}*/}
                {/*/>*/}
            </CardContent>
        </Card>
    );
}
